import React from "react";
import DisplayComponent from "./DisplayComponent";
import { Lifter, Meet } from "types";
import get from "lodash/get";

const TeamName = ({
  meet,
  currentLifter,
  id,
}: {
  meet: Meet;
  currentLifter: Lifter | undefined | null;
  id: string;
}) => {
  return (
    <DisplayComponent style={{ top: 80, left: 0 }} id={id}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style = {
          fontSize: sizeMultiplier * 22,
          width: sizeMultiplier * 600,
        };

        const teamName = currentLifter
          ? get(currentLifter, "team", "")
          : "Team Name";

        return (
          <div style={style} className="lifter-details">
            {teamName}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default TeamName;
